import { TranslationChunksConfig, TranslationResources } from '@spartacus/core';
import { en } from './en/index';
import { frCA } from './fr-CA/index';

export const knbrHomeTranslations: TranslationResources = { en, fr_CA: frCA };

export const knbrHomeTranslationChunksConfig: TranslationChunksConfig = {
  knbrHome: ['counter', 'customer', 'quicklinks'],
};
